import {
  debounce,
  EllipsisVerticalIcon,
  EyeIcon,
  initDropdowns,
  Link,
  PencilSquareIcon,
  Tooltip,
  TrashIcon,
  useEffect,
  useMemo,
  useState,
} from "@";

const Actions = (props) => {
  return (
    <>
      {/* Dropdown menu / inline actions */}
      <div className={`w-fit rounded-2xl bg-white dark:bg-gray-800`}>
        <ul
          aria-labelledby={`action-dropdownButton-${props.row.id}`}
          className="flex flex-nowrap justify-start overflow-hidden rounded-2xl"
        >
          {props.url ? (
            <>
              {!props.notShow && (
                <>
                  <Link
                    className="icon-style"
                    data-tooltip-placement="right"
                    to={`/${props.url}/${props.row.id}`}
                    data-tooltip-target={`action-a-${props.row.id}`}
                  >
                    <EyeIcon className="w-5" />
                  </Link>
                  <Tooltip
                    className="dark:bg-gray-600"
                    title="عرض"
                    id={`action-a-${props.row.id}`}
                  />
                </>
              )}
              {!props.notEdit && (
                <>
                  <Link
                    className="icon-style"
                    data-tooltip-placement="right"
                    to={`/${props.url}/${props.row.id}/edit`}
                    data-tooltip-target={`action-b-${props.row.id}`}
                  >
                    <PencilSquareIcon className="w-5" />
                  </Link>
                  <Tooltip
                    className="dark:bg-gray-600"
                    title="تعديل"
                    id={`action-b-${props.row.id}`}
                  />
                </>
              )}
            </>
          ) : (
            <>
              {!props.notShow && (
                <>
                  <span
                    data-tooltip-placement="right"
                    className="icon-style cursor-pointer"
                    onClick={() => props.show(props.row)}
                    data-tooltip-target={`action-c-${props.row.id}`}
                  >
                    <EyeIcon className="w-5" />
                  </span>
                  <Tooltip
                    className="dark:bg-gray-600"
                    title="عرض"
                    id={`action-c-${props.row.id}`}
                  />
                </>
              )}

              {!props.notEdit && (
                <>
                  <span
                    data-tooltip-placement="right"
                    className="icon-style cursor-pointer"
                    onClick={() => props.edit(props.row)}
                    data-tooltip-target={`action-d-${props.row.id}`}
                  >
                    <PencilSquareIcon className="w-5" />
                  </span>
                  <Tooltip
                    className="dark:bg-gray-600"
                    title="تعديل"
                    id={`action-d-${props.row.id}`}
                  />
                </>
              )}
            </>
          )}

          {!props.notDelete && (
            <>
              <span
                data-tooltip-placement="right"
                className="icon-style cursor-pointer hover:!bg-red-50 hover:!text-red-600 dark:hover:!bg-red-950/40 dark:hover:!text-red-400"
                onClick={() => props.delete(props.row.id)}
                data-tooltip-target={`action-e-${props.row.id}`}
              >
                <TrashIcon className="w-5" />
              </span>
              <Tooltip
                className="dark:bg-gray-600"
                title="حذف"
                id={`action-e-${props.row.id}`}
              />
            </>
          )}

          {props.children}
        </ul>
      </div>
    </>
  );
};

export default Actions;
